import { Children, isValidElement } from 'react';
import hasComplexChildren from './hasComplexChildren.js';
const deepForEach = (children, deepForEachFn) => {
    Children.forEach(children, (child, index) => {
        if (isValidElement(child) && hasComplexChildren(child)) {
            // Each inside the child that has children
            deepForEach(child.props.children, deepForEachFn);
        }
        deepForEachFn(child, index);
    });
};
export default deepForEach;
//# sourceMappingURL=deepForEach.js.map